/*
 * Copyright (c) 2022 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 22/11/2022
 */


import { createSlice } from "@reduxjs/toolkit";

export const offerSlice = createSlice({
  name: "offer",
  initialState: {
    modalStatus: false,
    selectedOffer: null,
    offerPageOpen: false,
  },
  reducers: {
    openAddOfferModal: (state) => {
      state.modalStatus = "add"; 
    },

    openEditOfferModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedOffer = action.payload;
      state.offerPageOpen = action.payload;
    },
    openDeleteOfferModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedOffer = action.payload;
    },
    closeOfferModal: (state) => {
      state.modalStatus = false;
      state.selectedOffer = null;
    }
  }
});

export const {
  openAddOfferModal,
  openEditOfferModal,
  openDeleteOfferModal,
  closeOfferModal
} = offerSlice.actions;

export default offerSlice.reducer;



